/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import React from 'react'

import { JIRA_BASE, type MigrationStatus } from './types'

const CLASS: Record<MigrationStatus, string> = {
  todo: 'badge-ghost',
  ready: 'badge-info',
  confirmed: 'badge-success',
  rejected: 'badge-error',
}

export const StatusBadge: React.FC<{ status: MigrationStatus }> = ({ status }) => (
  <span className={`badge badge-sm ${CLASS[status]}`}>{status}</span>
)

export const JiraLink: React.FC<{ jiraKey: string | null }> = ({ jiraKey }) =>
  jiraKey ? (
    <a href={`${JIRA_BASE}${jiraKey}`} target="_blank" rel="noreferrer" className="link link-primary">
      {jiraKey}
    </a>
  ) : (
    <span className="text-base-content/40">—</span>
  )
